<div class="d-flex flexAlign-center flexJustify--start flexWrap-wrap--xs flexGap-0050 mt-0050">
  <div class="txt-15 nowrap">in the previous</div>
  <div class="d-flex flexAlign-center flexGap-0050 time-period-inputs">
    <mat-form-field [ngClass]="{'ongray': inputTheme === 'white'}"
                    class="col__ col__xs--20 mb-0 compact flexGrow-1">
      <input matInput
            type="tel"
            autocomplete="off"
            name="units"
            [ngModel]="units"
            (ngModelChange)="unitsChanged($event)">
    </mat-form-field>
    <mat-form-field [ngClass]="{'ongray': inputTheme === 'white'}"
                    class="col__ col__xs--35 compact mb-0 flexGrow-1">
      <mat-select placeholder="Days"
                  [disableRipple]="true"
                  name="period"
                  [value]="selectedPeriod"
                  (selectionChange)="periodChanged($event)">
        <mat-option *ngFor="let period of timePeriods"
                    [value]="period.value">{{period.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <button (click)="onResetClick()"
          class="bg-color--trans color--red ml-auto">Clear</button>
  </div>
</div>
